import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "../../../helpers/endpointService";
import Pagination from "react-js-pagination";
import Autocomplete from "react-autocomplete";
import downArrow from "../../../assets/svg/downarrow.svg";
import upArrow from "../../../assets/svg/uparrow.svg";
import Select from "react-select";
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import AddIcon from "../../../assets/svg/addIcon.svg";
import RemoveIcon from "../../../assets/svg/removeIcon.svg";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import CommonSearch from "../..//pages/search/Search";
import EditIcon from "../../../assets/svg/editIcon.svg";
import CategoryIcon from "../../../assets/svg/categorymaxIcon.svg";
import ButtonSubmitIcon from "../../../assets/svg/submitbuttonIcon.svg";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import SearchIcon from "../../../assets/svg/search.svg";
import ReactPaginate from "react-paginate";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import $ from "jquery";
import { logoutFunction } from "../../custom/commonFunction";
import moment from "moment";
import Filter from "../../../assets/svg/filter.svg";
import search from "../../../assets/svg/search.svg";

const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];
const paginglistDefault = [{ label: "20", value: 20 }];
var closeNewSearch = false;

class Category2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "parentCategoryName",
      height: window.innerHeight,
      isMobile: false,
      isCategory2Failed: false,
      isCategory2Loader: false,
      isRadioMobile: false,
      isCancelMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      category2List: undefined,
      searchCategory1List: [],
      category2ArryList: [],
      isCategory2AddHide: false,
      isCategory2DeleteHide: false,
      isCategory2EditHide: false,
      categoryEmpty: false,
      categoryDropdownEmpty: false,
      currentPage: 1,
      perPage: 20,
      userId: 0,
      totalCount: 0,
      addcategoryValue: {
        categoryName: "",
        isSubCategory: true,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: "",
      },
      editcategoryValue: {
        categoryName: "",
        isSubCategory: true,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: "",
      },
      isView: false,
      isFormValid: true,
      searchCategory2List: [],
      searchInputCategory1: "",
      searchInputCategory2: "",
    };
  }
  componentDidMount() {
    this.GetCategory2List();
    let user = localStorage.getItem("UserId");
    this.state.userId = user;
    this.setState({});
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  GetCategory2List = (page) => {
    const { currentPage, perPage } = this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_CATAGORY2_LIST}?sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.category2List = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.setState({}, () => {
            this.GetCategory1DropdownList();
          });
        }
      })
      .catch((error) => {
        this.setState({ isCategory2Loader: false, isCategory2Failed: false });

        logoutFunction(error?.response?.status);
      });
  };
  GetCategory1DropdownList = () => {
    const { dispatch } = this.props;
    let apiUrl = `${API.GET_CATAGORY2}?category1Id=0`;
    axios({
      method: "POST",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.searchCategory1List = res.data?.map((res) => {
            return {
              value: res.category1Id,
              label: res.category1Name,
            };
          });
          this.state.isCategory2Loader = false;
          this.state.isCategory2Failed = false;
          this.setState({});
          //this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        }
      })
      .catch((error) => {
        this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        logoutFunction(error?.response?.status);
      });
  };
  GetCategory2 = (id) => {
    const { currentPage, perPage, userId } = this.state;
    let data = {
      pageNumber: parseInt(currentPage),
      pagesize: parseInt(perPage),
    };

    let apiUrl = `${API.GET_CATAGORY2}?category1Id=${id}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory2List = res.data.values?.map((res) => {
          return {
            label: res.category2Name,
            value: res.category2Id,
          };
        });
        this.setState({});
      }
    });
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 450) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = true;
    }
    if (window.innerWidth < 300) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 315) {
      this.state.isCancelMobile = true;
    } else {
      this.state.isCancelMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };
  find = (e) => {
    this.state.perPage = e.value;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    const selectedPage = 1;
    this.state.currentPage = selectedPage;
    this.setState({}, () => {
      this.GetCategory2List();
    });
  };
  handlePageChange = (pageNumber) => {
    this.state.currentPage = pageNumber;
    this.setState({}, () => {
      //console.log(this.state.currentPage);
    });
    this.GetCategory2List();
  };

  handlecategoryInputchange(e, field, type) {
    if (type === "Add") {
      this.state.addcategoryValue[field] = e.target.value;
      this.setState({});
    } else if (type === "Edit") {
      this.state.editcategoryValue[field] = e.target.value;
      this.setState({});
    }
  }

  handleSearchSelectChange = (value, field) => {
    if (field === "parentCategoryName") {
      if (value) {
        this.state.addcategoryValue[field] = value;
        this.state.addcategoryValue["categoryName"] = "";
        this.setState({}, () => {});
      } else {
        this.state.addcategoryValue[field] = "";
        this.state.addcategoryValue["categoryName"] = "";
        this.setState({}, () => {});
      }
    }
  };

  OpenAddcategory2 = () => {
    this.GetCategory1DropdownList();
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addCategory2Screen")
    );
    myOffcanvas.show();
    this.state.category2ArryList = [];
    this.setState({});
    $("body").addClass("scrollhide");
  };
  handleCheckbox = (x) => {
    const { category2ArryList } = this.state;
    if (category2ArryList?.length == 0) {
      category2ArryList.push(x);
    } else {
      if (
        category2ArryList &&
        category2ArryList?.filter((i) => i == x)?.length == 1
      ) {
        category2ArryList?.map((i, ind) =>
          i == x ? category2ArryList.splice(ind, 1) : ""
        );
      } else {
        category2ArryList.push(x);
      }
    }
    this.setState({});
  };
  handleChangeChecked = (x) => {
    const { category2ArryList } = this.state;
    if (category2ArryList?.length == 0) {
      category2ArryList.push(x);
    } else {
      if (
        category2ArryList &&
        category2ArryList.filter((i) => i == x)?.length == 1
      ) {
        category2ArryList?.map((i, ind) =>
          i == x ? category2ArryList.splice(ind, 1) : ""
        );
      } else {
        category2ArryList.push(x);
      }
    }
    this.setState({});
  };
  handleCheckboxTop = () => {
    let data = [];
    if (
      this.state.category2ArryList?.length !=
        this.state.category2List?.length &&
      this.state.category2ArryList?.length > 0 &&
      this.state.category2List?.length > 0
    ) {
      this.state.category2List?.map((r) => data.push(r.categoryId));
    }

    if (
      this.state.category2ArryList?.length == 0 &&
      this.state.category2List?.length > 0
    ) {
      this.state.category2List?.map((r) => data.push(r.categoryId));
    }

    if (
      this.state.category2ArryList?.length ==
        this.state.category2List?.length &&
      this.state.category2List?.length > 0
    ) {
      data = [];
    }
    this.state.category2ArryList = data;
    this.setState({});
  };
  GetCategoryValue = (isView, id) => {
    const { currentPage, perPage } = this.state;
    var ids = this.state.category2ArryList;
    var CategoryId = id || ids?.toString();
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    let apiUrl = `${API.GET_CATAGORY2_LIST}?category2Id=${CategoryId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          let categoryvalue = ids.toString();
          if (res.data?.values?.length !== 0) {
            const GetData = {
              categoryName: res.data.values[0].categoryName,
              isSubCategory: true,
              categoryId: res.data.values[0].categoryId,
              parentCategoryId: res.data.values[0].parentCategoryId,
              parentCategoryName: res.data.values[0].parentCategoryName,
              historyLog: res.data.values[0]?.historyLog || [],
            };
            this.state.editcategoryValue = GetData;
            this.setState({});
          } else {
            const GetData = {
              categoryName: "",
              isSubCategory: true,
              categoryId: 0,
              parentCategoryId: res.data.values[0]?.parentCategoryId
                ? res.data.values[0]?.parentCategoryId
                : 0,
              parentCategoryName: res.data.values[0]?.parentCategoryName
                ? res.data.values[0]?.parentCategoryName
                : "",
              historyLog: res.data.values[0]?.historyLog || [],
            };
            this.state.editcategoryValue = GetData;
            this.setState({});
          }
          const newLocal = "editCategory2Screen";
          let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById(newLocal)
          );
          myOffcanvas.show();
          $("body").addClass("scrollhide");
          this.setState({
            isCategory2Loader: false,
            isCategory2Failed: false,
            isView: isView,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isCategory2Loader: false,
          isCategory2Failed: false,
          isView: false,
        });
        logoutFunction(error?.response?.status);
      });
  };
  AddCategory() {
    const { addcategoryValue, userId } = this.state;
    let Categoryadd = [
      {
        categoryName: addcategoryValue.categoryName
          ? addcategoryValue.categoryName
          : "",
        isSubCategory: true,
        categoryId: this.state.addcategoryValue.parentCategoryName.value
          ? this.state.addcategoryValue.parentCategoryName.value
          : 0,
        parentCategoryId: 0,
      },
    ];
    if (Categoryadd[0].categoryName !== "" && Categoryadd[0].categoryId !== 0) {
      let apiurl1 = `${API.EXIST_CATEGORYNAME}?category1Id=${this.state.addcategoryValue.parentCategoryName.value}&categoryname=${Categoryadd[0].categoryName}&type=category2`;
      this.setState({ isCategory2Loader: true, isCategory2Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.POST_MASTERDATA}?userId=${userId}`;
          this.setState({ isCategory2Loader: true, isCategory2Failed: false });
          axios({
            method: "POST",
            url: apiUrl,
            data: Categoryadd,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearAddCategory2();
                this.GetCategory2List();
                toast.success("Category added successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                // this.setState({
                //   isCategory2Loader: false,
                //   isCategory2Failed: false,
                // });
              }
            })
            .catch((error) => {
              this.setState({
                isCategory2Loader: false,
                isCategory2Failed: false,
              });
              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "This category name is already given. Please give another name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (
      Categoryadd[0].categoryName === "" &&
      Categoryadd[0].categoryId === 0
    ) {
      this.state.categoryEmpty = true;
      this.state.categoryDropdownEmpty = true;
      this.setState({});
    } else if (Categoryadd[0].categoryName === "") {
      this.state.categoryEmpty = true;
      this.state.categoryDropdownEmpty = false;
      this.setState({});
    } else if (Categoryadd[0].categoryId === 0) {
      this.state.categoryEmpty = false;
      this.state.categoryDropdownEmpty = true;
      this.setState({});
    }
  }
  UpdateCategory = () => {
    const { editcategoryValue, userId } = this.state;
    let Categoryedit = [
      {
        categoryName: editcategoryValue.categoryName,
        isSubCategory: true,
        categoryId: editcategoryValue.categoryId
          ? parseInt(editcategoryValue.categoryId)
          : 0,
        parentCategoryId: parseInt(editcategoryValue.parentCategoryId),
      },
    ];
    if (Categoryedit[0].categoryName !== "") {
      let apiurl1 = `${API.EXIST_CATEGORYNAME}?category1Id=${this.state.editcategoryValue.parentCategoryId}&categoryname=${Categoryedit[0].categoryName}&type=category2`;
      this.setState({ isCategory2Loader: true, isCategory2Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.PUT_MASTERDATA}?userId=${userId}`;
          this.setState({ isCategory2Loader: true, isCategory2Failed: false });
          axios({
            method: "PUT",
            url: apiUrl,
            data: Categoryedit,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearCategory2Edit();
                this.GetCategory2List();
                toast.success("Category edited successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                // this.setState({
                //   isCategory2Loader: false,
                //   isCategory2Failed: false,
                // });
              }
            })
            .catch((error) => {
              this.setState({
                isCategory2Loader: false,
                isCategory2Failed: false,
              });
              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "This category name is already given. Please give another category name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (Categoryedit[0].categoryName === "") {
      this.state.categoryEmpty = true;
      this.setState({});
    }
  };
  OpenRemoveCategory2 = () => {
    var ids = this.state.category2ArryList;
    let apiurl1 = `${API.IS_DOCUMENT_PRESENT_CAT}?type=category2`;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    axios({
      method: "POST",
      url: apiurl1,
      data: ids,
    })
      .then((res) => {
        if (res.data?.length === 0) {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          let cancelPopup = new window.bootstrap.Modal(
            document.getElementById("RemoveCategory2Screen")
          );
          cancelPopup.show();
          $("body").addClass("scrollhide");
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "Sorry you cannot delete the category when documents exist in it.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
      .catch((error) => {
        this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        logoutFunction(error?.response?.status);
      });
  };

  DeleteCategory = () => {
    const { editcategoryValue, userId, category2ArryList } = this.state;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    let apiUrl = `${API.DELETE_MASTERDATA}?userId=${userId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: category2ArryList,
    })
      .then((res) => {
        if (res.status === 200) {
          this.clearDeletedArray();
          this.GetCategory2List();
          toast.success("Category deleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        }
      })
      .catch((error) => {
        this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        logoutFunction(error?.response?.status);
      });
  };
  ClearAddCategory2 = () => {
    this.state.categoryEmpty = false;
    this.state.categoryDropdownEmpty = false;
    let data = {
      categoryName: "",
      isSubCategory: false,
      categoryId: 0,
      parentCategoryId: 0,
      parentCategoryName: "",
    };
    this.state.addcategoryValue = data;
    this.setState({});
    $("#addCategory2Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
  };
  ClearCategory2Edit = () => {
    this.state.categoryEmpty = false;
    this.state.categoryDropdownEmpty = false;
    this.state.category2ArryList = [];
    this.setState({});
    $("#editCategory2Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
  };
  clearDeletedArray = () => {
    $("body").removeClass("scrollhide");
    $(".offcanvas-backdrop").removeClass("show");
    this.state.category2ArryList = [];
    this.setState({});
  };
  cancelDeletePopup = () => {
    $("body").removeClass("scrollhide");
    $(".offcanvas-backdrop").removeClass("show");
  };

  sortTable = (name) => {
    if (this.state.category2List?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.GetCategory2List();
      });
    }
  };

  OpenPendingSearch = () => {
    this.GetCategory1DropdownList();
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingSearchScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar8");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.setState({ isFormValid: true });
  };

  // GetDropdownCategory1 = () => {
  //   let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   }).then((res) => {
  //     if (res.status === 200) {
  //       this.state.searchCategory1List = res.data?.map((res) => {
  //         return {
  //           value: res.categoryId,
  //           label: res.categoryName,
  //         };
  //       });
  //       this.setState({});
  //     }
  //   });
  // };

  handleSearchCategoryChange = (value, field) => {
    //SelectedValueSearch = true;
    if (field === "category1") {
      if (value) {
        this.state.searchInputCategory1 = value;
        this.state.searchInputCategory2 = "";
        this.setState({}, () => {
          this.GetCategory2(value.value);
        });
      } else {
        this.state.searchInputCategory1 = "";
        this.setState({});
      }
    }
    if (field === "category2") {
      if (value) {
        this.state.searchInputCategory2 = value;
        this.setState({});
      } else {
        this.state.searchInputCategory2 = "";
        this.setState({});
      }
    }
  };

  validatesubmitSearch = () => {
    var category1Input = this.state.searchInputCategory1 ? true : false;
    var category2Input = this.state.searchInputCategory2 ? true : false;
    let isValid = category1Input || category2Input ? true : false;
    if (isValid) {
      this.submitSearch();
    } else {
      this.setState({ isFormValid: false });
    }
  };

  submitSearch = () => {
    const { currentPage, perPage, userId } = this.state;
    this.setState({
      isCategory2Loader: true,
      isCategory2Failed: false,
      isFormValid: true,
    });
    let order = this.state.order === "asc" ? true : false;
    var searchDetails;

    if (closeNewSearch) {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        category1Id: 0,
        category1Name: null,
        category2Id: 0,
        category2Name: null,
      };
    } else {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        category1Id: this.state.searchInputCategory1
          ? this.state.searchInputCategory1.value
          : 0,
        category1Name: this.state.searchInputCategory1
          ? this.state.searchInputCategory1.label
          : null,
        category2Id: this.state.searchInputCategory2
          ? this.state.searchInputCategory2.value
          : 0,
        category2Name: this.state.searchInputCategory2
          ? this.state.searchInputCategory2.label
          : null,
      };
    }

    //let apiUrl = `${API.GET_CATAGORY2}?category1Id=0&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    let apiUrl = `${API.GET_CATAGORY2_LIST}?sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: searchDetails,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.category2List = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.isCategory2Loader = false;
          this.state.isCategory2Failed = false;
          closeNewSearch = false;
          this.setState({}, () => {
            this.closeSearch();
          });
          //this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      // .catch((error) => {
      //
      //   this.setState({ isCategory1Loader: false, isCategory1Failed: false });
      //   logoutFunction(error?.response?.status);
      // });
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Failed to search. Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  closeSearch = () => {
    // $("#pendingSearchScreen").removeClass("show");
    document.getElementById("closeSearchButton").click();
    $("body").removeClass("scrollhide");
  };

  clearSearch = () => {
    this.state.searchInputCategory1 = "";
    this.state.searchInputCategory2 = "";
    closeNewSearch = true;
    this.submitSearch();
  };

  render() {
    const {
      isCategory2Loader,
      isCategory2Failed,
      isMobile,
      isRadioMobile,
      isSmallMobile,
      category2ArryList,
      category2List,
      addcategoryValue,
      currentPage,
      isCategory2EditHide,
      isCategory2AddHide,
      isCategory2DeleteHide,
      perPage,
      sortBy,
      order,
      editcategoryValue,
      isFormValid,
      searchCategory2List,
      searchCategory1List,
    } = this.state;
    let { classes, category2CommonSearchResult, menuToggle, category1List } =
      this.props;
    return (
      <>
        {$("#addCategory2Screen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : $("#editCategory2Screen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div className={`${isMobile ? "main-body-mobile" : "main-body"}`}>
          {isCategory2Loader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isCategory2Failed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}
          {isMobile == true ? (
            <div className="head-fixed">
              <div className="mobile-head border-bottom w-100">
                <div
                  className="col-12 mobile-title"
                  style={{ paddingLeft: "2px" }}
                >
                  Category 2
                </div>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                <div
                  className={`col-12  ${isMobile ? "pl-1 pr-0" : "pl-10"} `}
                  // d-flex justify-content-start
                >
                  <button
                    className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${
                      isSmallMobile ? "pl-5" : ""
                    }`}
                    id="displaybuttoncolor"
                    onClick={() => this.OpenAddcategory2()}
                  >
                    <img src={AddIcon} />
                    <span className={`subhead-span p-2`}>Add</span>
                  </button>
                  {category2ArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.GetCategoryValue(false, NaN)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {category2ArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveCategory2()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  <button
                    className="displaybutton"
                    id="displaybuttoncolor"
                    style={{ float: "inline-end" }}
                    onClick={() => this.OpenPendingSearch()}
                  >
                    <img
                      src={Filter}
                      // style={{ marginTop: "-4px", float: "right" }}
                    ></img>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <img src={CategoryIcon} />
                <span className="pl-10 head-span mt-10">Category 2</span>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                <div
                  className={`col-9  ${isMobile ? "pl-1 pr-0" : "pl-10"} `}
                  style={{ width: "80%" }}
                  // d-flex justify-content-start
                >
                  <button
                    className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${
                      isSmallMobile ? "pl-5" : ""
                    }`}
                    id="displaybuttoncolor"
                    onClick={() => this.OpenAddcategory2()}
                  >
                    <img src={AddIcon} />
                    <span className={`subhead-span p-2`}>Add</span>
                  </button>
                  {category2ArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.GetCategoryValue(false, NaN)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {category2ArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveCategory2()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  <button
                    className="displaybutton"
                    id="displaybuttoncolor"
                    onClick={() => this.OpenPendingSearch()}
                    style={{ float: "inline-end" }}
                  >
                    <img
                      src={Filter}
                      // style={{ marginTop: "-4px", float: "right" }}
                    ></img>
                  </button>
                </div>
              </div>
            </div>
          )}
          <ToastContainer limit={1} />

          <div
            className={`${
              isMobile ? "favorite-mobile-table1 " : "favorite-table1 "
            } table-responsive  table-fixed-header table-responsive-height`}
            style={{ width: "100%" }}
          >
            <table className="table fileListTable2 table-borderless table-hover">
              <thead className="thead-sticky  thead-color">
                <tr>
                  <td className="wid-7">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      name="request"
                      checked={
                        category2List?.length !== 0
                          ? category2ArryList?.length == category2List?.length
                            ? true
                            : false
                          : false
                      }
                      onClick={() => this.handleCheckboxTop()}
                    />
                  </td>
                  <td
                    className={!isMobile ? "wid-18" : ""}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("parentCategoryName")}
                  >
                    <span>Category 1</span>
                    {sortBy === "parentCategoryName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    className={!isMobile ? "wid-18" : ""}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("categoryName")}
                  >
                    <span> Category 2</span>
                    {sortBy === "categoryName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {category2List?.length !== 0 ? (
                  category2List?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          category2ArryList?.filter((r) => r == item.categoryId)
                            ?.length > 0
                            ? "#f3f2f1"
                            : "",
                      }}
                      onDoubleClick={() =>
                        this.handleChangeChecked(item.categoryId)
                      }
                    >
                      <td>
                        <input
                          type="checkbox"
                          className="cursor-pointer"
                          name="request"
                          checked={
                            category2ArryList?.filter(
                              (r) => r == item.categoryId
                            )?.length > 0
                              ? true
                              : false
                          }
                          onClick={() => this.handleCheckbox(item.categoryId)}
                        />
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo"
                          title={item.parentCategoryName}
                        >
                          {item.parentCategoryName}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo tablefilename text-12-bold"
                          onClick={() =>
                            this.GetCategoryValue(true, item.categoryId)
                          }
                          title={item.categoryName}
                        >
                          {item.categoryName}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="table-nodata">
                      {category2List && "No record found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          >
            {category2List?.length !== 0 ? (
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div
                        className={`${
                          this.state.iswebMobile
                            ? "mobilePageSelect"
                            : "webpageSelect"
                        }`}
                      >
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td
                      width="92%"
                      className={`text-end ${
                        this.state.isCancelMobile ? "pagination-padd" : "p-3"
                      }`}
                    >
                      {this.state.isMobile ? (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      ) : (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={3}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="addCategory2Screen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Add category
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle pr-0 `} //${isMobile ? "pr-0" : ""}
              style={{ backgroundColor: "white" }}
              onClick={() => this.ClearAddCategory2()}
            >
              <img
                src={CrossIcon}
                className="cursor-pointer app-image-hover mb-1"
                height={15}
              />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 ">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div>
                  <label
                    className={`label-text mb-2 ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 1
                    </span>
                  </label>
                  <div
                    className={`${
                      this.state.categoryDropdownEmpty === true
                        ? "border-red"
                        : ""
                    }`}
                  >
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={this.state.addcategoryValue.parentCategoryName}
                      options={this.state.searchCategory1List}
                      defaultValue={
                        this.state.addcategoryValue.parentCategoryName ||
                        "Select"
                      }
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        this.handleSearchSelectChange(e, "parentCategoryName")
                      }
                    />
                  </div>
                  {this.state.categoryDropdownEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 2
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Add")
                    }
                    className="form-control border-radius shiptype-select mt-2"
                    value={addcategoryValue.categoryName}
                    maxLength={250}
                    style={{
                      fontSize: "12px",
                      height: "34.5px",
                      borderColor:
                        this.state.categoryEmpty === true ? "#d12232" : "",
                    }}
                  />
                  {this.state.categoryEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <button
                className={`btn btn-light input-group f-size-13 d-flex ${
                  isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                } p-2`}
                onClick={() => this.AddCategory()}
              >
                <img src={ButtonSubmitIcon} className="modal-img"></img>
                <span style={{marginTop:"1px"}} className="model-label pl-10 obsoletebtn">Submit</span>
              </button>
            </div>
          </div>
        </div>
        <div
          className={`offcanvas offcanvas-end offcanvasStyle ${
            this.state.isView ? "audit-offcanvas" : ""
          }`}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="editCategory2Screen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-2"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              {this.state.isView ? "Category" : "Edit category"}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle pr-0`} //${isMobile ? "pr-0" : ""}
              style={{ backgroundColor: "white" }}
              onClick={() => this.ClearCategory2Edit()}
            >
              <img
                src={CrossIcon}
                className="cursor-pointer app-image-hover mb-1"
                height={15}
              />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0">
            {this.state.isView && (
              <div>
                <button
                  className={`displaybutton p-0`}
                  id="displaybuttoncolor"
                  onClick={() =>
                    this.GetCategoryValue(false, editcategoryValue.categoryId)
                  }
                >
                  <img src={EditIcon} />
                  <span className={`subhead-span p-2`}>Edit</span>
                </button>
              </div>
            )}
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      {" "}
                      Category 1
                    </span>
                  </label>
                  <input
                    className="form-control border-radius shiptype-select mt-2"
                    value={editcategoryValue.parentCategoryName}
                    style={{ fontSize: "12px" }}
                    disabled={true}
                  />
                </div>{" "}
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      {" "}
                      Category 2
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Edit")
                    }
                    className="form-control border-radius shiptype-select mt-2"
                    value={editcategoryValue.categoryName}
                    disabled={this.state.isView}
                    maxLength={250}
                    style={{
                      fontSize: "12px",
                      borderColor:
                        this.state.categoryEmpty === true ? "#d12232" : "",
                    }}
                  />

                  {this.state.categoryEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
            </div>
            {!this.state.isView && (
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button
                  className={`btn btn-light input-group f-size-13 d-flex ${
                    isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                  } p-2`}
                  onClick={() => this.UpdateCategory()}
                >
                  <img src={ButtonSubmitIcon} className="modal-img"></img>
                  <span style={{marginTop:"1px"}} className="model-label pl-10 obsoletebtn">Submit</span>
                </button>
              </div>
            )}
            {this.state.isView && editcategoryValue?.historyLog?.length > 0 && (
              <div>
                <div className="">
                  <h6 className="modal-title">Audit log</h6>
                </div>
                <div className="audit-table-wrapper audit-scroll-css">
                  <table className="px-3 audit-table">
                    <thead>
                      <tr className="border-bottom">
                        <th className="p-rem">Action</th>
                        <th className="p-rem">Action By</th>
                        <th className="p-rem wid-45">Description</th>
                        <th className="p-rem">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {editcategoryValue?.historyLog.map((x) => (
                        <tr className="border-bottom">
                          <td className="p-rem">{x.action}</td>
                          <td className="p-rem">{x.actionBy}</td>
                          <td className="p-rem">{x.description}</td>
                          <td className="p-rem">
                            {moment
                              .utc(x.createdTime)
                              .local()
                              .format("DD-MMM-YYYY hh:mm A")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Reomve Popup code */}
        <div
          className="modal fade modal-style"
          id="RemoveCategory2Screen"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header pb-2 pl-20">
                <h5
                  className="modal-title d-flex pl-10"
                  id="exampleModalLongTitle"
                >
                  <img src={WarningIcon} />
                  &nbsp;<span className="mt-1 pl-5"></span>Warning
                </h5>
              </div>
              <div className="modal-body pl-20">
                <h5 className="warning-text">
                  {" "}
                  Are you sure you want to remove the category ?
                </h5>
                <span className="app-label">
                  {" "}
                  All the subcategories or documents will be deleted.
                </span>
              </div>
              <div className="modal-footer border-top-none justify-content-center pb-3">
                <button
                  className={`btn btn-light input-group  d-flex ${
                    isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                  } `}
                  data-bs-dismiss="modal"
                  onClick={() => this.cancelDeletePopup()}
                >
                  <span className="rejectedstatus-color pl-10">No</span>{" "}
                </button>
                <button
                  className={`btn btn-light input-group d-flex ${
                    isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                  data-bs-dismiss="modal"
                  onClick={() => this.DeleteCategory()}
                >
                  <span style={{fontSize:"14px"}} className="model-label pl-10">Yes</span>{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Common search */}
        <div
          className="offcanvas offcanvas-end offcanvaspendingStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="pendingSearchScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose  buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              data-bs-dismiss="offcanvas"
              id="closeSearchButton"
              onClick={() => this.closeSearch()}
              style={{ backgroundColor: "white" }}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 " id="viewbar8">
            <div className="row">
              <div
                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2`}
                // className="col-sm-6 col-12 mt-2 mb-2"
              >
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={SubCategoryIcon} alt="" />
                  <span> Category 1</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputCategory1}
                  options={searchCategory1List}
                  defaultValue={this.state.searchInputCategory1 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchCategoryChange(value, "category1")
                  }
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={SubCategoryIcon} alt="" />
                  <span> Category 2</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputCategory2}
                  options={searchCategory2List}
                  isDisabled={!this.state.searchInputCategory1}
                  defaultValue={this.state.searchInputCategory2 || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchCategoryChange(value, "category2")
                  }
                />
              </div>
            </div>

            {!isFormValid && (
              <p style={{ color: "red" }}>At least one field is mandatory</p>
            )}

            <div className="button" style={{ display: "flex" }}>
              <button id="edit2" onClick={() => this.clearSearch()}>
                <span className="clear-icon-position">✕</span>
                <span>Clear</span>
              </button>
              <button id="edit" onClick={() => this.validatesubmitSearch()}>
                <img
                  style={{
                    marginTop: "-4px",
                    marginRight: "4px",
                    width: "14px",
                  }}
                  src={search}
                  alt=""
                />
                Search
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    category1List: state.commonReducer.Category1List,
    category2CommonSearchResult:
      state.commonReducer.category2CommonSearchResult,
    sideMenu: state.commonReducer.sideMenu,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Category2)
);
